import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade, makeStyles } from '@material-ui/core';
import NotificationCard from '../notificationCard';
import Scrollbars from '../scrollbars';
import BackgroundImage from '../../../assets/images/bck_leveling.png';
import { isObject, isObjectEmpty } from '../../../utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    backgroundColor: primary.bluish9,
    position: 'relative',
    height: 'calc(100vh - 187px)',
    padding: spacing(5, 9),
  },
  rootNoData: {
    background: `${primary.white} url(${BackgroundImage}) center center / cover no-repeat`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  },
  previewWrapper: {
    boxSizing: 'border-box',
    backgroundColor: primary.white,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  previewContent: {
    margin: spacing(2),
  },
  noSelection: {
    backgroundColor: 'transparent',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    padding: 0,
  },
  noSelectionTitle: {
    width: 538,
  },
  noSelectionContent: {
    fontSize: 16,
    lineHeight: '24px',
    width: 538,
    marginTop: spacing(4),
  },
  scrollY: {
    right: -21,
  },
}));

const PreviewField = ({
  translations,
  component: Preview,
  data = null,
  isExpandedOnFirstOpen,
  handleIsExpandedOnFirstOpen,
  isExpandedOnFirstOpenFramework,
  handleIsExpandedOnFirstOpenFramework,
}) => {
  const classes = useStyles();
  const hasPreview = isObject(data) && !isObjectEmpty(data);

  return (
    <div
      className={classNames(classes.root, {
        [classes.rootNoData]: !hasPreview,
      })}
    >
      <Fade in={hasPreview} unmountOnExit>
        <div className={classNames(classes.previewWrapper)}>
          <Scrollbars verticalScrollClass={classes.scrollY}>
            <div className={classes.previewContent}>
              <Preview
                translations={translations.preview}
                data={data?.value?.frameworks}
                isExpandedOnFirstOpen={isExpandedOnFirstOpen}
                toggleExpansion={handleIsExpandedOnFirstOpen}
                isExpandedOnFirstOpenFramework={isExpandedOnFirstOpenFramework}
                toggleExpansionFramework={handleIsExpandedOnFirstOpenFramework}
              />
            </div>
          </Scrollbars>
        </div>
      </Fade>
      <NotificationCard
        className={classes.noSelection}
        titleClass={classes.noSelectionTitle}
        contentClass={classes.noSelectionContent}
        title={translations.noSelection.title}
        titleVariant="h3"
        content={translations.noSelection.content}
        shouldFade={!hasPreview}
      />
    </div>
  );
};

PreviewField.propTypes = {
  translations: PropTypes.object.isRequired,
  component: PropTypes.elementType.isRequired,
  data: PropTypes.object,
};

export default PreviewField;
